import React from 'react';
import FilterControl from '../FilterControl';
import { ViewFilterName } from '../../../../enum/types/ViewFilterName';

const FileDateFilterControls: React.FC = () => {
  return (
    <>
      <FilterControl name={ViewFilterName._FileDate} />
    </>
  );
};

export default FileDateFilterControls;
